<template>
  <div>
    <Title class="center-title">项目备案</Title>
    <template>
      <div v-if="projectNameMatchList.length > 0 && detail.userName === '毛笑湧'" style="padding: 4px 0;">
        <a-table
            :data-source="projectNameMatchList"
            :pagination="projectNameMatchTotal > 20 ? projectNameMatchPagination : false"
            size="small"
            bordered
            row-key="id"
            :loading="projectNameSearching"
            @change="onProjectNameMatchTableChange"
        >
          <a-table-column title="序号" width="60px" align="center">
            <template slot-scope="text, record, index">
              {{ (projectNameMatchPagination.current - 1) * projectNameMatchPagination.pageSize + index + 1 }}
            </template>
          </a-table-column>
          <a-table-column title="备案编号" data-index="filingNum" width="160px"/>
          <a-table-column title="备案名称" data-index="projectName"/>
          <a-table-column title="创建人" data-index="author"/>
          <a-table-column title="创建时间" data-index="createTime">
            <template slot-scope="text">
              {{ text ? text.toString().replace('T', ' ').slice(0, 19) : '—' }}
            </template>
          </a-table-column>
        </a-table>
      </div>
      <div class="panel">
        <div class="label">项目名称</div>
        <div class="value3">{{ extra.projectName }}</div>

        <div class="label">备案编号</div>
        <div class="value1">{{ extra.filingNum }}</div>
        <div class="label">主办生产部门</div>
        <div class="value2">{{ extra.productionDeptName || '—' }}</div>

        <div class="label">业主单位</div>
        <div class="value1">{{ extra.customerName }}</div>
        <div class="label">来源单位</div>
        <div class="value2">{{ extra.sourceCustomerName }}</div>

        <div class="label">联系人</div>
        <div class="value1">{{ extra.contactName }}</div>
        <div class="label">来源联系人</div>
        <div class="value2">{{ extra.sourceContactName }}</div>

        <div class="label">项目属性</div>
        <div class="value1">{{ extra.projectProperty }}</div>

        <div class="label">项目概况</div>
        <div class="value2">{{ extra.projectSurvey }}</div>

        <div class="label">信息来源</div>
        <div class="value1">
          <DataDictFinder dictType="scrm.scrm_info_source" :dictValue="extra.infoSource"/>
        </div>
        <div class="label">信息获取时间</div>
        <div class="value2">{{ extra.infoGetTime | dateFormat }}</div>

        <div class="label">预计合同金额(万)</div>
        <div class="value1">{{ extra.estimateContractAmount }}</div>
        <div class="label">预计开标时间</div>
        <div class="value2">{{ extra.estimateOpenBidTime | dateFormat }}</div>

        <div class="label">总投资额(万)</div>
        <div class="value1">{{ extra.totalInvestmentAmount }}</div>
        <div class="label">登记人</div>
        <div class="value2">{{ extra.registerUserName }}</div>

        <div class="label">是否大客户</div>
        <div class="value1">{{ extra.isMajorClient === 1 ? '是' : '否' }}</div>
        <div class="label">登记部门</div>
        <div class="value2">{{ extra.registerDeptName }}</div>

        <div class="label">生产部门负责人</div>
        <div class="value1">{{ extra.chargeUserName }}</div>
        <div class="label">是否总院投标类重点项目</div>
        <div class="value2">{{ extra.pointFlag === 1 ? '是' : '否' }}</div>

        <div class="label">省份</div>
        <div class="value1">{{ extra.provinceCode }}</div>
        <div class="label">城市</div>
        <div class="value2">{{ extra.cityCode }}</div>

        <div class="label">区域</div>
        <div class="value1">{{ extra.regionCode }}</div>
        <div class="label">是否为区域项目</div>
        <div class="value2">
          <a-tag :color="extra.isArea === 1 ? 'green' : 'red'">{{ extra.isArea === 1 ? '是' : '否' }}</a-tag>
          <span v-if="extra.isArea === 1">{{extra.areaName}}</span>
        </div>

        <div class="label">附件</div>
        <div class="value3">
          <template v-if="fileList.length > 0">
            <div v-for="item in fileList" :key="item.id">
              <a :href="item.completePath" target="_blank" @click.prevent="handleFileClick($event, item.completePath, item.name || item.fileName)">{{ item.name || item.fileName || item.completePath }}</a>
            </div>
          </template>
        </div>
      </div>
    </template>
    <Padding/>
  </div>
</template>

<script>
import {mapState} from "vuex";
import Title from "../Title";
import {getProjectFilingList} from "@/api/market/projectFiling";
import moment from "moment/moment";

export default {
  components: {Title},
  data() {
    return {
      projectNameMatchList: [],
      projectNameMatchTotal: 0,
      projectNameMatchPagination: {current: 1, pageSize: 20, total: 0, showTotal: total => `共 ${total} 条`},
      projectNameSearching: false,
    };
  },
  watch: {
    'detail.extra.projectName': {
      immediate: true,
      handler(val) {
        if (val && this.detail.userName === '毛笑湧') {
          this.fetchProjectNameMatch(val, 1);
        }
      },
    },
  },
  filters: {
    dateFormat(val) {
      if (!val) return '-';
      return moment(val).format('YYYY-MM-DD');
    },
  },
  computed: {
    ...mapState("approval", ["detail"]),
    extra() {
      return this.detail.extra ? this.detail.extra : {};
    },
    fileList() {
      return this.extra.attachmentFileList || [];
    },
  },
  methods: {
    isPdfFile(filename) {
      return filename && filename.toLowerCase().endsWith('.pdf');
    },
    previewPdf(url, filename) {
      const routeUrl = this.$router.resolve({
        path: '/pdf-preview',
        query: { url, title: filename || 'PDF预览' }
      }).href;
      window.open(routeUrl, '_blank');
    },
    deepDecodeURIComponent(str) {
      // 仅当结果中仍含 %25（编码的百分号）时才继续解码：
      // %25 是"还有一层编码未解"的唯一信号；没有 %25 时再解码会破坏
      // URL 中合法的编码字符（如文件名的 %2B、OSS 签名参数的 %2F），导致下载/查看链接失效
      let decoded = str;
      while (decoded.includes('%25')) {
        const prev = decoded;
        try {
          decoded = decodeURIComponent(decoded);
        } catch (e) {
          break;
        }
        if (decoded === prev) break;
      }
      return decoded;
    },
    handleFileClick(event, url, filename) {
      event.preventDefault();
      const decodedUrl = this.deepDecodeURIComponent(url);
      if (this.isPdfFile(filename)) {
        this.previewPdf(decodedUrl, filename);
      } else {
        const a = document.createElement('a');
        a.href = decodedUrl;
        a.download = filename || '';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    },
    fetchProjectNameMatch(name, page) {
      this.projectNameSearching = true;
      getProjectFilingList({projectName: name, statusNotEqual: "Cancel", pageNum: page, pageSize: 20, idNotEqual: this.extra.id})
          .then((res) => {
            this.projectNameMatchList = res.list || [];
            this.projectNameMatchTotal = res.totalSize || res.total || 0;
            this.projectNameMatchPagination = {
              ...this.projectNameMatchPagination,
              current: page,
              total: this.projectNameMatchTotal,
            };
          })
          .catch(() => {
          })
          .finally(() => {
            this.projectNameSearching = false;
          });
    },
    onProjectNameMatchTableChange(pagination) {
      this.projectNameMatchPagination = {...this.projectNameMatchPagination, current: pagination.current};
      const name = this.extra.projectName;
      if (name) {
        this.fetchProjectNameMatch(name, pagination.current);
      }
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .center-title {
  font-size: 24px;
  left: 0;
  text-align: center;
  margin-top: -65px;
  margin-bottom: 30px;
  margin-left: 150px;

  &::before {
    display: none;
  }
}

.panel {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  border-top: 1px solid #e8e8e8;

  & > div {
    padding: 8px;
    border-bottom: 1px solid #e8e8e8;
  }

  .label {
    background-color: #fafafa;
    border-right: 1px solid #e8e8e8;
    border-left: 1px solid #e8e8e8;
  }

  .value1 {
    grid-column-start: 2;
    grid-column-end: 4;
  }

  .value2 {
    grid-column-start: 5;
    grid-column-end: 7;
    border-right: 1px solid #e8e8e8;
  }

  .value3 {
    grid-column-start: 2;
    grid-column-end: 7;
    border-right: 1px solid #e8e8e8;
  }
}
</style>
